import { Tab } from "@mui/material";
import { styled } from "@mui/material/styles"; // use MUI's styled (better TS support)

export const AGTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  color: theme.palette.text.primary,
  "&.Mui-selected": {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));